import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';

import Configuration from '../Config';
import { getCardExpansion, updateCardExpansion } from '../actions/cardExpansionActions';
import CardExpansionForm from '../components/CardExpansionForm';


const validation = Configuration.Validations.editStockAccount;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class EditCardExpansion extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    componentDidMount() {
        this.props.dispatch(getCardExpansion(this.id));
    }

    handleSave = (values) => {
        this.props.dispatch(updateCardExpansion(this.props.cardExpansion.id, values));
    }

    render() {
        if(!this.props.cardExpansion || !this.props.cardExpansion.name) {
            return <Pane>Se incarca...</Pane>
        }
        
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/card-expansions">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista extensii
                            </Button>
                        </Link>
                    </Pane>
                    
                    <Pane marginLeft={16}>
                        <Link to={`/card-expansions/${this.id}`}>
                            <Button iconBefore="cross" intent="warning">
                                Anuleaza modificarile
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Modificare Extensie - <strong>{this.props.cardExpansion.name}</strong>
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <CardExpansionForm 
                            isEdit={true}
                            initialValues={this.props.cardExpansion}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.cardExpansions.errors.type === 'validation' ? mapValidationErrors(state.stockAccounts.errors.fields): [],
        cardExpansion: state.cardExpansions.current
    }
}

export default connect(mapStateToProps)(EditCardExpansion);